import request from '../../axios';

const getUnSeenChat = async () => {
  const {data}: {data: IUseGetUnSeenChat} = await request.get(
    `api/v2/shop/chat/unseen-count`,
  );

  return data;
};

export default getUnSeenChat;
